module.exports = "/assets/0393b0aa19c97b0ee7953d877055e26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PW.png
// module id = 1731
// module chunks = 0